import videoAsset from "@/assets/mikrobiom-video.mp4.asset.json";
import { absoluteUrl } from "@/lib/seo";

export const videoJsonLd = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  name: "Das Mikrobiom – Zentrum unserer Gesundheit",
  description:
    "Ein wissenschaftlicher Kurzfilm über Aufbau, Kommunikation und Immunfunktion unseres Mikrobioms. Von der intakten Darmbarriere, Quorum Sensing, kurzkettigen Fettsäuren und dendritischen Zellen über Dysbiose, Leaky-Gut und klinische Auswirkungen bis hin zu moderner Diagnostik und individueller Therapie in der Praxis IB.",
  thumbnailUrl: absoluteUrl("/og.png"),
  contentUrl: absoluteUrl(videoAsset.url),
  uploadDate: "2026-07-18",
  duration: "PT4M50S",
  encodingFormat: "video/mp4",
  author: {
    "@type": "Organization",
    name: "PRAXIS IB",
    url: absoluteUrl("/"),
  },
  publisher: {
    "@type": "Organization",
    name: "PRAXIS IB",
    url: absoluteUrl("/"),
  },
};

const MikrobiomVideo = () => {
  return (
    <section id="mikrobiom-video" className="py-12 md:py-16 bg-secondary/30">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-8 md:mb-10">
          <p className="text-sm font-medium text-primary uppercase tracking-wider mb-3">
            Wissen kompakt
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Das Mikrobiom – Zentrum unserer Gesundheit
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Ein wissenschaftlicher Kurzfilm über Aufbau, Kommunikation und Immunfunktion
            unseres Mikrobioms – und was geschieht, wenn das Gleichgewicht kippt.
          </p>
        </div>

        <div className="rounded-2xl overflow-hidden shadow-2xl border border-border bg-background">
          <video
            src={videoAsset.url}
            controls
            preload="metadata"
            playsInline
            className="w-full h-auto block"
            aria-label="Mikrobiom-Erklärvideo der Praxis IB"
          >
            Ihr Browser unterstützt kein HTML5-Video.
          </video>
        </div>

        <div className="mt-6 md:mt-8 max-w-3xl mx-auto text-muted-foreground leading-relaxed">
          <p className="text-sm italic pt-4 border-t border-border/60">
            Hinweis: Dieses Video wurde KI-gestützt erstellt, dient der allgemeinen Information
            und ersetzt keine individuelle Beratung oder ärztliche Diagnose.
          </p>

        </div>

      </div>
    </section>
  );
};

export default MikrobiomVideo;
